<header>
  <h1 mat-dialog-title class="truncate">
    <mat-icon fontIcon="settings"></mat-icon>
    Settings
  </h1>
  <aside>
    <mat-icon title="Close" (click)="close()" fontIcon="close"></mat-icon>
  </aside>
</header>
<mat-dialog-content>
  <h2 class="sync-text heading-underline">
    <mat-icon title="calendar" fontSet="material-symbols-outlined">calendar_add_on</mat-icon>
    Sync with your calendar
  </h2>
  <table class="table-striped full-width table-no-border-bottom">
    <tr class="calendar-option" [class.disabled]="outlookLoading"
      [style.pointer-events]="outlookLoading ? 'none' : 'auto'" (click)="selectCalendar('outlook')"
      [matTooltip]=outlookEmail
      [matTooltipShowDelay]="500">
      <td>
        <span>
          <img src="assets/integration_icons/Microsoft_Office_Outlook_(2018–present).svg" alt="Outlook" width="21"
            height="21">
            <div>
              Outlook
            </div>
            @if (outlookLoading || outlookStatus === 'connecting') {
              <span>
                <div class="loading-spinner spinner-border spinner-border-sm calendar-spinner"></div>
              </span>
            }
            @if (outlookStatus === 'connected') {
              <span class="calendar-email truncate">{{ outlookEmail }}</span>
            }
          </span>
          @if (outlookStatus === 'connected') {
            <div class="calendar-buttons">
              <button [class.disabled]="outlookLoading" [style.pointer-events]="outlookLoading ? 'none' : 'auto'"
                (click)="signOut('outlook'); $event.stopPropagation()" class="sign-out-btn">SIGN OUT
              </button>
            </div>
          }
        </td>
      </tr>

      <!--<tr class="calendar-option" [class.disabled]="outlookLoading" [style.pointer-events]="outlookLoading ? 'none' : 'auto'" (click)="selectCalendar('google')">
      <td>
        <span>
          <img src="assets/integration_icons/Google_Calendar_icon_(2020).svg" alt="Google Calendar" width="18" height="18">
          Google Calendar
          <app-loading-spinner *ngIf="googleStatus === 'connecting'" type="inline" label="" class="calendar-spinner"></app-loading-spinner>
          <span *ngIf="googleStatus === 'connected'" class="calendar-email">{{ googleEmail }}</span>
        </span>
        <div *ngIf="googleStatus === 'connected'" class="calendar-buttons">
          <button (click)="signOut('google'); $event.stopPropagation()" class="sign-out-btn">SIGN OUT</button>
        </div>
        <div *ngIf="googleStatus === 'error' || googleStatus === 'disconnected'" class="calendar-buttons">
          <button (click)="reauthenticate('google'); $event.stopPropagation()" class="sign-out-btn">REAUTHENTICATE</button>
        </div>
      </td>
    </tr>-->
  </table>
</mat-dialog-content>
<section mat-dialog-actions class="footer-btns one-button">
  <button class="danger-btn-hover" (click)="close()" tabindex="0">cancel</button>
</section>
